import { api } from '@/app/api'
import type {
  DashboardOverview,
  LeaderboardEntry,
  TopCustomerEntry,
  TopProductEntry,
  TargetVsActualEntry,
  TrendDay,
} from './reports-types'

interface DateRangeParams {
  from?: string
  to?: string
  limit?: number
}

interface MonthlyParams {
  year: number
  month: number
  limit?: number
}

interface TvAParams extends MonthlyParams {
  scope_type?: string
  scope_id?: number
}

export const reportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    dashboardOverview: build.query<{ data: DashboardOverview }, void>({
      query: () => '/v1/dashboard/overview',
    }),
    repLeaderboard: build.query<{ data: LeaderboardEntry[]; meta?: unknown }, DateRangeParams>({
      query: (params) => ({ url: '/v1/dashboard/leaderboard', params }),
    }),
    topCustomers: build.query<{ data: TopCustomerEntry[]; meta?: unknown }, MonthlyParams>({
      query: (params) => ({ url: '/v1/dashboard/top-customers', params }),
    }),
    topProducts: build.query<{ data: TopProductEntry[]; meta?: unknown }, MonthlyParams>({
      query: (params) => ({ url: '/v1/dashboard/top-products', params }),
    }),
    salesTrend: build.query<{ data: TrendDay[] }, DateRangeParams>({
      query: (params) => ({ url: '/v1/dashboard/trend', params }),
    }),
    targetVsActual: build.query<{ data: TargetVsActualEntry[] }, TvAParams>({
      query: (params) => ({ url: '/v1/dashboard/target-vs-actual', params }),
    }),

    // Reports by category (real backend endpoints)
    salesReports: build.query<{ data: Record<string, unknown>[] }, { page?: number; per_page?: number }>({
      query: (params) => ({ url: '/v1/reports/sales-by-day', params }),
    }),
    inventoryReports: build.query<{ data: Record<string, unknown>[] }, { page?: number; per_page?: number }>({
      query: (params) => ({ url: '/v1/reports/low-stock', params }),
    }),
    financialReports: build.query<{ data: Record<string, unknown>[] }, { page?: number; per_page?: number }>({
      query: (params) => ({ url: '/v1/reports/cheques-in-flight', params }),
    }),
    fieldForceReports: build.query<{ data: Record<string, unknown>[] }, { page?: number; per_page?: number }>({
      query: (params) => ({ url: '/v1/reports/inactive-customers', params }),
    }),
    pharmaReports: build.query<{ data: Record<string, unknown>[] }, { page?: number; per_page?: number }>({
      query: (params) => ({ url: '/v1/reports/sales-by-customer', params }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useDashboardOverviewQuery,
  useRepLeaderboardQuery,
  useTopCustomersQuery,
  useTopProductsQuery,
  useSalesTrendQuery,
  useTargetVsActualQuery,
  useSalesReportsQuery,
  useInventoryReportsQuery,
  useFinancialReportsQuery,
  useFieldForceReportsQuery,
  usePharmaReportsQuery,
} = reportsApi
